import { EventEmitter } from 'events';

export const C_RULES_CREATE_NEW_INTENT = 'C_RULES_CREATE_NEW_INTENT';

export default new EventEmitter();
